import React from 'react';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { CalendarIcon, PlusIcon, LayersIcon } from 'lucide-react';
export interface MasterEvent {
  id: string;
  name: string;
  dates: string;
  location: string;
  subEvents: SubEvent[];
  stats: {
    exhibitors: number;
    sessions: number;
    attendees: number;
  };
}
export interface SubEvent {
  id: string;
  name: string;
  type: 'B2B' | 'B2C';
  dates: string;
  color: string;
}
interface MasterEventSelectorProps {
  onSelect: (event: MasterEvent) => void;
}
export function MasterEventSelector({
  onSelect
}: MasterEventSelectorProps) {
  // Mock data for master events
  const masterEvents: MasterEvent[] = [{
    id: 'dubai-muscle-active-2026',
    name: 'Dubai Muscle / Active 2026',
    dates: '24-26 October 2026',
    location: 'Dubai Exhibition Centre',
    stats: {
      exhibitors: 255,
      sessions: 142,
      attendees: 35000
    },
    subEvents: [{
      id: 'muscle',
      name: 'Dubai Muscle Show',
      type: 'B2C',
      dates: '24-26 Oct',
      color: '#ef4444'
    }, {
      id: 'active',
      name: 'Dubai Active',
      type: 'B2C',
      dates: '24-26 Oct',
      color: '#3b82f6'
    }, {
      id: 'industry',
      name: 'Dubai Active Industry',
      type: 'B2B',
      dates: '24-26 Oct',
      color: '#10b981'
    }]
  }, {
    id: 'myplantgarden-2026',
    name: 'MyPlantGarden 2026',
    dates: '15-17 February 2026',
    location: 'Dubai World Trade Centre',
    stats: {
      exhibitors: 120,
      sessions: 45,
      attendees: 12000
    },
    subEvents: [{
      id: 'myplant',
      name: 'MyPlant Exhibition',
      type: 'B2B',
      dates: '15-17 Feb',
      color: '#22c55e'
    }, {
      id: 'garden',
      name: 'Garden Living',
      type: 'B2C',
      dates: '16-17 Feb',
      color: '#eab308'
    }]
  }];
  return <div className="space-y-6" data-id="element-1856">
      <div className="flex items-center justify-between" data-id="element-1857">
        <div data-id="element-1858">
          <h1 className="text-2xl font-bold text-gray-900 font-inter" data-id="element-1859">
            Event Portfolio
          </h1>
          <p className="text-gray-500 font-inter mt-1" data-id="element-1860">
            Select a master event to manage or create a new one.
          </p>
        </div>
        <Button variant="primary" onClick={() => console.log('Create event')} data-id="element-1861">
          <PlusIcon className="w-4 h-4 mr-2" data-id="element-1862" />
          Create Master Event
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1863">
        {masterEvents.map(event => <Card key={event.id} className="group cursor-pointer hover:border-blue-500 transition-all duration-200" onClick={() => onSelect(event)} padding="lg" data-id="element-1864">
            <div className="flex items-start justify-between mb-4" data-id="element-1865">
              <div className="p-3 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors" data-id="element-1866">
                <LayersIcon className="w-6 h-6 text-blue-600" data-id="element-1867" />
              </div>
              <span className="bg-gray-100 text-gray-600 text-xs font-medium px-2.5 py-0.5 rounded-full font-inter" data-id="element-1868">
                {event.subEvents.length} Sub-events
              </span>
            </div>

            <h3 className="text-xl font-bold text-gray-900 font-inter mb-2 group-hover:text-blue-600 transition-colors" data-id="element-1869">
              {event.name}
            </h3>

            <div className="flex items-center text-gray-500 text-sm font-inter mb-4" data-id="element-1870">
              <CalendarIcon className="w-4 h-4 mr-2" data-id="element-1871" />
              {event.dates}
            </div>

            <div className="border-t border-gray-100 pt-4 mt-4" data-id="element-1872">
              <div className="grid grid-cols-3 gap-2 text-center" data-id="element-1873">
                <div data-id="element-1874">
                  <div className="text-lg font-bold text-gray-900 font-inter" data-id="element-1875">
                    {event.stats.exhibitors}
                  </div>
                  <div className="text-xs text-gray-500 font-inter" data-id="element-1876">
                    Exhibitors
                  </div>
                </div>
                <div data-id="element-1877">
                  <div className="text-lg font-bold text-gray-900 font-inter" data-id="element-1878">
                    {event.stats.sessions}
                  </div>
                  <div className="text-xs text-gray-500 font-inter" data-id="element-1879">
                    Sessions
                  </div>
                </div>
                <div data-id="element-1880">
                  <div className="text-lg font-bold text-gray-900 font-inter" data-id="element-1881">
                    {(event.stats.attendees / 1000).toFixed(1)}k
                  </div>
                  <div className="text-xs text-gray-500 font-inter" data-id="element-1882">
                    Attendees
                  </div>
                </div>
              </div>
            </div>
          </Card>)}

        {/* Add New Card Placeholder */}
        <button className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center text-gray-400 hover:border-blue-500 hover:text-blue-500 transition-all duration-200 min-h-[280px]" data-id="element-1883">
          <PlusIcon className="w-12 h-12 mb-4" data-id="element-1884" />
          <span className="font-medium font-inter" data-id="element-1885">Add New Master Event</span>
        </button>
      </div>
    </div>;
}